import { AnimatedLoadingIcon } from '@velasca/icons/animated-loading-icon'
import { ArrowRightIcon } from '@velasca/icons/arrow-right'
import { Button } from '../Button/Button'
import { ButtonWrapper, Input, InputWrapper } from './InlineInput.styles'
import type { InlineInputProps } from './InlineInput.types'

export const InlineInput = ({
  className,
  error,
  loading = false,
  bordered = false,
  ...rest
}: InlineInputProps): JSX.Element => {
  return (
    <InputWrapper className={className}>
      <Input disabled={loading} bordered={bordered} error={error} {...rest} />
      <ButtonWrapper>
        <Button
          fullWidth
          $loading={loading}
          disabled={loading}
          Icon={loading ? AnimatedLoadingIcon : ArrowRightIcon}
          type="submit"
        />
      </ButtonWrapper>
    </InputWrapper>
  )
}
